import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Search } from './../../../../Common/Tables/Search'
import { InstructorBase } from './../../../../Layouts/Instructor/V2/InstructorBase'
import { Details } from './../../../../Common/Modals/Details'
import { Confirm } from './../../../../Common/Modals/Confirm'
import { GetZtudents, HideToZtudent, ShowToZtudent, ResetZtudiantePassword as BLResetZtudiantePassword } from './../../../../../utilities/BL/Instructor/Ztudents'
import { Loading } from './../../../../Common/Loading'

import { LogErrors } from './../../../../../utilities/LogErrors'
import { SaveGroupToShow } from './../../../../../utilities/BL/Navigation'
import { GetZtudentGroups } from './../../../../../utilities/BL/Instructor/Groups'
import { ValidateSession } from './../../../../../utilities/BL/Sessions'
import { useFloatMessage, MESSAGE_TYPE } from './../../../../Providers/FloatMessage'
import { HELP_TYPE } from './../../../../../utilities/EL/HelpType'
import { WEBPAGES } from './../../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../../utilities/EL/Roles'


const Ztudents = () => {
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()

    const [isLoading,setIsLoading] = useState(true)

    const [showDetailsModal,setShowDetailsModal] = useState(false)
    const [showConfirmationModal,setShowConfirmationModal] = useState(false)
    const [actionTypeOfModal,setActionTypeOfModal] = useState(null)

    const [ztudentDetails,setZtudentDetails] = useState(null)
    const [ztudentConfirmDetails,setZtudentConfirmDetails] = useState(null)

    const [massiveSummary, setMassiveSummary] = useState(null)
    const [showMassiveSummaryModal, setShowMassiveSummaryModal] = useState(false)
    
    const [showPreviousStepButton, setShowPreviousStepButton] = useState(false)
    const [showNextStepButton, setShowNextStepButton] = useState(false)

    const [visibleRows, setVisibleRows] = useState([])
    const [hiddenRows, setHiddenRows] = useState([])

    // Selección y ordenamiento para la tabla de visibles
    const [selectedVisibleIds, setSelectedVisibleIds] = useState([])
    const [sortVisibleConfig, setSortVisibleConfig] = useState({ key: null, direction: 'asc' })

    // Selección y ordenamiento para la tabla de ocultos
    const [selectedHiddenIds, setSelectedHiddenIds] = useState([])
    const [sortHiddenConfig, setSortHiddenConfig] = useState({ key: null, direction: 'asc' })

    const [searchVisibleText, setSearchVisibleText] = useState('')
    const [searchHiddenText, setSearchHiddenText] = useState('')

    const [currentDetailList, setCurrentDetailList] = useState([])

    const actions = {
        SHOW: "SHOW",
        HIDE: "HIDE",
        RESET: "RESET"
    }

    //--- Commons to Table and Search ---//

    const [allRows, setAllRows] = useState([])
    const allRowsRef = useRef([])

    useEffect(() => {
        allRowsRef.current = allRows
    }, [allRows])

    // useEffect(() => {
    //     const filtered = visibleRows.filter((row) =>
    //         row.name.toLowerCase().includes(searchVisibleText.toLowerCase())
    //     )
    //     setFilteredVisibleRows(filtered)
    // }, [searchVisibleText, visibleRows])

    // useEffect(() => {
    //     const filtered = hiddenRows.filter((row) =>
    //         row.name.toLowerCase().includes(searchHiddenText.toLowerCase())
    //     )
    //     setFilteredHiddenRows(filtered)
    // }, [searchHiddenText, hiddenRows])

    // VISIBLES: filtra + ordena
    const processedVisibleRows = useMemo(() => {
        const filtered = visibleRows.filter((row) =>
            (row.name ?? '').toLowerCase().includes(searchVisibleText.toLowerCase())
    )

    if (!sortVisibleConfig.key) return filtered

    return [...filtered].sort((a, b) => {
        const aVal = a[sortVisibleConfig.key]
        const bVal = b[sortVisibleConfig.key]

        return typeof aVal === 'string'
            ? (sortVisibleConfig.direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal))
            : (sortVisibleConfig.direction === 'asc' ? aVal - bVal : bVal - aVal)
    })
    }, [visibleRows, searchVisibleText, sortVisibleConfig])

    // OCULTOS: filtra + ordena
    const processedHiddenRows = useMemo(() => {
        const filtered = hiddenRows.filter((row) =>
            (row.name ?? '').toLowerCase().includes(searchHiddenText.toLowerCase())
    )

    if (!sortHiddenConfig.key) return filtered

    return [...filtered].sort((a, b) => {
        const aVal = a[sortHiddenConfig.key]
        const bVal = b[sortHiddenConfig.key]

        return typeof aVal === 'string'
            ? (sortHiddenConfig.direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal))
            : (sortHiddenConfig.direction === 'asc' ? aVal - bVal : bVal - aVal)
    })
    }, [hiddenRows, searchHiddenText, sortHiddenConfig])

    //--- Commons to Table and Search ---//


    //--- Funciones para visibles ---//
    const isVisibleSelected = (idZtudiante) => selectedVisibleIds.includes(idZtudiante)
    const toggleVisibleSelect = (idZtudiante) => {
        setSelectedVisibleIds((prev) =>
            prev.includes(idZtudiante)
                ? prev.filter(i => i !== idZtudiante)
                : [...prev, idZtudiante]
        )
    }
    const handleSortVisible = (key) => {
        setSortVisibleConfig((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
            }
            return { key, direction: 'asc' }
        })
    }
    const sortedVisibleRows = useMemo(() => {
        if (!sortVisibleConfig.key) return visibleRows
        return [...visibleRows].sort((a, b) => {
            const aVal = a[sortVisibleConfig.key]
            const bVal = b[sortVisibleConfig.key]
            return typeof aVal === 'string'
                ? (sortVisibleConfig.direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal))
                : (sortVisibleConfig.direction === 'asc' ? aVal - bVal : bVal - aVal)
        })
    }, [visibleRows, sortVisibleConfig])

    //--- Funciones para visibles ---//

    //--- Funciones para ocultos ---//
    const isHiddenSelected = (idZtudiante) => selectedHiddenIds.includes(idZtudiante)
    const toggleHiddenSelect = (idZtudiante) => {
        setSelectedHiddenIds((prev) =>
            prev.includes(idZtudiante)
                ? prev.filter(i => i !== idZtudiante)
                : [...prev, idZtudiante]
        )
    }
    const handleSortHidden = (key) => {
        setSortHiddenConfig((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
            }
            return { key, direction: 'asc' }
        })
    }
    const sortedHiddenRows = useMemo(() => {
        if (!sortHiddenConfig.key) return hiddenRows
        return [...hiddenRows].sort((a, b) => {
            const aVal = a[sortHiddenConfig.key]
            const bVal = b[sortHiddenConfig.key]
            return typeof aVal === 'string'
                ? (sortHiddenConfig.direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal))
                : (sortHiddenConfig.direction === 'asc' ? aVal - bVal : bVal - aVal)
        })
    }, [hiddenRows, sortHiddenConfig])

    //--- Funciones para ocultos ---//
    

    //--- Calls to API ----//

    const ClearSelections = async () => {
        try {
            setSelectedVisibleIds([])
            setSelectedHiddenIds([])
        } catch (error) {
            await LogErrors('ClearSelections - Ztudents', error)
        }
    }

    const GetSelectedZtudentsByIds = async (ids) => {
        try {
            return ids.map(id => allRows.find(z => z.idZtudiante === id))
        } catch (error) {
            await LogErrors('GetSelectedZtudentsByIds - Ztudents', error)
        }
    }

    const HandleMassiveZtudentAction = async ({ selectedRows, actionLabel, actionFn, _actionTypeOfModal, allRowsRef, setAllRows, setVisibleRows, setHiddenRows, setMassiveSummary, setShowMassiveSummaryModal, setActionTypeOfModal, ClearSelections, logContext = '' }) => {
        try {
            const resumen = {
                successful: [],
                wrongs: [],
                omitteds: []
            }

            let currentRows = [...allRowsRef.current]

            for (const ztudent of selectedRows) {
                try {
                    const stillExists = currentRows.find(z => z.idZtudiante === ztudent.idZtudiante)
                    if (!stillExists) {
                        resumen.omitteds.push({ ...ztudent, reason: 'Ya no existe en el listado' })
                        continue
                    }

                    const response = await actionFn(ztudent, currentRows)

                    if (response.success) {
                        resumen.successful.push(ztudent)
                        currentRows = response.data
                    } else {
                        resumen.wrongs.push({ ...ztudent, error: response.message ?? 'Error desconocido' })
                    }
                } catch (error) {
                    resumen.wrongs.push({ ...ztudent, error: error.message })
                }
            }

            // Actualizar tablas
            setAllRows(currentRows)
            setVisibleRows(currentRows.filter(z => z.isVisible))
            setHiddenRows(currentRows.filter(z => !z.isVisible))

            setMassiveSummary(resumen)
            setShowMassiveSummaryModal(true)
            setActionTypeOfModal(_actionTypeOfModal)

            await ClearSelections()
        } catch (error) {
            await LogErrors(`${actionLabel} - Ztudents ${logContext}`, error)
        }
    }

    const HideZtudent = async () => {
        try {
            if (ztudentConfirmDetails) {
                const response = await HideToZtudent(ztudentConfirmDetails, allRowsRef.current)

                if (response.success) {
                    showMessage({
                        type: MESSAGE_TYPE.SUCCESS,
                        text: `El Ztudiante ${ztudentConfirmDetails.name} ${ztudentConfirmDetails.lastName} (${ztudentConfirmDetails.user}) ha sido ocultado exitosamente.`
                    })
                    //console.log(`El Ztudiante ${ztudentConfirmDetails.name} ${ztudentConfirmDetails.lastName} (${ztudentConfirmDetails.user}) ha sido ocultado exitosamente.`)

                    setAllRows(response.data)
                    setVisibleRows(response.data.filter(z => z.isVisible))
                    setHiddenRows(response.data.filter(z => !z.isVisible))
                }

                // Devuelvo la respuesta a la tabla. Ahí es donde la tabla cerrará el modal o mostrará el mensaje de error en el modal.
                return response
            }
        } catch (error) {
            await LogErrors('HideZtudent - Ztudents', error)
        }
    }

    const ShowZtudent = async () => {
        try {
            if (ztudentConfirmDetails) {
                const response = await ShowToZtudent(ztudentConfirmDetails, allRowsRef.current)

                if (response.success) {
                    showMessage({
                        type: MESSAGE_TYPE.SUCCESS,
                        text: `El Ztudiante ${ztudentConfirmDetails.name} ${ztudentConfirmDetails.lastName} (${ztudentConfirmDetails.user}) ha sido mostrado exitosamente.`
                    })
                    //console.log(`El Ztudiante ${ztudentConfirmDetails.name} ${ztudentConfirmDetails.lastName} (${ztudentConfirmDetails.user}) ha sido mostrado exitosamente.`)

                    setAllRows(response.data)
                    setVisibleRows(response.data.filter(z => z.isVisible))
                    setHiddenRows(response.data.filter(z => !z.isVisible))
                }

                // Devuelvo la respuesta a la tabla. Ahí es donde la tabla cerrará el modal o mostrará el mensaje de error en el modal.
                return response
            }
        } catch (error) {
            await LogErrors('ShowZtudent - Ztudents', error)
        }
    }

    const ResetZtudiantePassword = async () => {
        try {
            if (ztudentConfirmDetails) {
                const response = await BLResetZtudiantePassword(ztudentConfirmDetails)
                
                if (response.success) {
                    showMessage({
                        type: MESSAGE_TYPE.SUCCESS,
                        text: `Se ha reiniciado exitosamente la contraseña del Ztudiante ${ztudentConfirmDetails.name} ${ztudentConfirmDetails.lastName} (${ztudentConfirmDetails.user}).`
                    })
                    //console.log(`Se ha reiniciado exitosamente la contraseña del Ztudiante ${ztudentConfirmDetails.name} ${ztudentConfirmDetails.lastName} (${ztudentConfirmDetails.user}).`)
                }

                // Devuelvo la respuesta a la tabla. Ahí es donde la tabla cerrará el modal o mostrará el mensaje de error en el modal.
                return response
            }
        } catch (error) {
            await LogErrors('ResetZtudiantePassword - Ztudents', error)
        }
    }

    //--- Calls to API ----//
    


    //--- Confirm Modal ----//
    
    const ShowConfirmModal = async (actionType, ztudent) => {
        try {
            if (actionType && ztudent) {
                if (actionType === actions.HIDE || actionType === actions.SHOW || actionType === actions.RESET) {
                    setActionTypeOfModal(actionType)
                    setZtudentConfirmDetails(ztudent)
                    setShowConfirmationModal(true)
                } else {
                    setActionTypeOfModal(null)
                    setZtudentConfirmDetails(null)
                    setShowConfirmationModal(false)
                    return
                }
            }
        } catch (error) {
            await LogErrors('ShowConfirmModal - Ztudents', error)
        }
    }

    //--- Confirm Modal ----//
    
    

    //--- Details Modal ----//

    const ShowOrHideStepsButtons = async (index, list) => {
        try {
            // Checar si habilito o deshabilito el botón Previous (dependiendo de si hay otros Ztudiantes anteriores por mostrar, o si no, se oculta)
            if (index > 0) {
                setShowPreviousStepButton(true)
            } else {
                setShowPreviousStepButton(false)
            }
            
            // Checar si habilito o deshabilito el botón Next (dependiendo de si hay otros Ztudiantes posteriores por mostrar, o si no, se oculta)
            if (index < (list.length - 1)) {
                setShowNextStepButton(true)
            } else {
                setShowNextStepButton(false)
            }
        } catch (error) {
            await LogErrors('ShowOrHideStepsButtons - Ztudents', error)
        }
    }

    const ShowZtudentDetails = async (ztudent, baseList) =>{
        try {
            // Obtener información de row en allRows (ya que puede ser más info de la que se muestra en la tabla y en allRows sí trae todo) y almacena en ztudentDetails
            const tmpZtudentDetails = allRowsRef.current.find((row) => row.idZtudiante === ztudent.idZtudiante)
            if (!tmpZtudentDetails) {
                return
            }
            
            // Obtener los grupos del Ztudiante
            const response = await GetZtudentGroups(ztudent)
            const finalZtudent = response.success ? { ...tmpZtudentDetails, groups: response.data } : tmpZtudentDetails
            setZtudentDetails(finalZtudent)
            setCurrentDetailList(baseList)

            // Obtener el índice del Ztudiante actual
            const currentIndex = baseList.findIndex((row) => row.idZtudiante === ztudent.idZtudiante)

            //await ShowOrHideStepsButtons(currentZtudentIndex)
            await ShowOrHideStepsButtons(currentIndex, baseList)

            // Mostrar modal Details después de que se imprimió la info
            setShowDetailsModal(true)
        } catch (error) {
            await LogErrors('ShowZtudentDetails - Ztudents', error)
        }
    }

    const PreviousStepButton = async () => {
        try {
            if (!ztudentDetails || currentDetailList.length === 0) return

            // Obtener el índice del Ztudiante actual
            const currentIndex = currentDetailList.findIndex((row) => row.idZtudiante === ztudentDetails.idZtudiante)

            const prevIndex = currentIndex - 1
            if (prevIndex >= 0) {
                // Obtener los grupos del Ztudiante
                const response = await GetZtudentGroups(currentDetailList[prevIndex])
                const finalZtudent = response.success ? { ...currentDetailList[prevIndex], groups: response.data } : currentDetailList[prevIndex]
                // Almacena la info del Ztudiante
                setZtudentDetails(finalZtudent)
                // Mostrar modal Details después de que se imprimió la info 
                await ShowOrHideStepsButtons(prevIndex, currentDetailList)
            }
        } catch (error) {
            await LogErrors('PreviousStepButton - Ztudents', error)
        }
    }
    
    const NextStepButton = async () => {
        try {
            if (!ztudentDetails || currentDetailList.length === 0) return

            // Obtener el índice del Ztudiante actual
            const currentIndex = currentDetailList.findIndex((row) => row.idZtudiante === ztudentDetails.idZtudiante)

            const nextIndex = currentIndex + 1
            if (nextIndex < currentDetailList.length) {
                // Obtener los grupos del Ztudiante
                const response = await GetZtudentGroups(currentDetailList[nextIndex])
                const finalZtudent = response.success ? { ...currentDetailList[nextIndex], groups: response.data } : currentDetailList[nextIndex]
                // Almacena la info del Ztudiante
                setZtudentDetails(finalZtudent)
                // Mostrar modal Details después de que se imprimió la info
                await ShowOrHideStepsButtons(nextIndex, currentDetailList)
            }
        } catch (error) {
            await LogErrors('NextStepButton - Ztudents', error)
        }
    }

    //--- Details Modal ----//
    
    const ShowGroup = async (group) => {
        try {
            // Guardar en navigation el grupo para detectarlo en la página /groups/group
            const response = await SaveGroupToShow(group.idGroup, group.groupName)

            if (response.success) {
                navigate("/instructor/groups/group/")
            }
        } catch (error) {
            
        }
    }

    const LoadPage = async () => {
        try {
            const response = await GetZtudents()

            if (response.success) {
                setAllRows(response.data)
                setVisibleRows(response.data.filter(z => z.isVisible))
                setHiddenRows(response.data.filter(z => !z.isVisible))
            } else {

            }
        } catch (error) {
            await LogErrors('LoadPage - Ztudents', error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage()
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    }, [])


    //useTawkChat(true) // Activamos el chat en esta página

    
    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <InstructorBase urlToGo={'/dashboard'} idHelp={HELP_TYPE.INSTRUCTOR.ZTUDENTS} page={WEBPAGES.INSTRUCTOR.ZTUDENTS} role={ROLES.INSTRUCTOR}>
                    <section className='container Instructor__Ztudents'>
                        <p className='Instructor__Title Instructor__Title--Center'>Mis Ztudiantes</p>

                        {allRows && (
                            <>
                                {visibleRows && (
                                    visibleRows.length > 0 && (
                                        <p className='Instructor__Subtitle Instructor__Subtitle--Center'>Total: {visibleRows.length}</p>
                                    )
                                )}

                                {visibleRows ? (
                                    <>
                                        {visibleRows.length === 0 ? (
                                            allRows.length === 0 ? (
                                                <p className='Instructor__Text--Center Instructor__SpaceUp'>Actualmente no hay Ztudiantes asociados a tu centro o no han confirmado su invitación.</p>
                                            ) : (
                                                <p className='Instructor__Text--Center Instructor__SpaceUp'>Actualmente no hay Ztudiantes visibles.</p>
                                            )
                                        ) : (
                                            <>
                                                <Search onChange={(v) => setSearchVisibleText(v)} extraClassName={'Instructor__SpaceUp'} />

                                                <div className='container Instructor__SpaceUp Tables--Shadow Tables--Background'>
                                                    {selectedVisibleIds.length > 0 && (
                                                        <div className='Tables__ExtraButtons'>
                                                            <button
                                                                className='Btn__Ztudia--PrimaryOutline Tables__ExtraButtons__Button'
                                                                onClick={async () => {
                                                                    const selectedZtudents = await GetSelectedZtudentsByIds(selectedVisibleIds)

                                                                    await HandleMassiveZtudentAction({
                                                                        selectedRows: selectedZtudents,
                                                                        actionLabel: 'Ocultar',
                                                                        actionFn: HideToZtudent,
                                                                        _actionTypeOfModal: actions.HIDE,
                                                                        allRowsRef,
                                                                        setAllRows,
                                                                        setVisibleRows,
                                                                        setHiddenRows,
                                                                        setMassiveSummary,
                                                                        setShowMassiveSummaryModal,
                                                                        setActionTypeOfModal,
                                                                        ClearSelections,
                                                                        logContext: '- ocultar visibles'
                                                                    })
                                                                }}
                                                            >
                                                                Ocultar {selectedVisibleIds.length} Ztudiante(s)
                                                            </button>
                                                        </div>
                                                    )}

                                                    {selectedVisibleIds.length > 0 && (
                                                        <div className='Tables__Table__RegistersSelected'>
                                                            <button className='Tables__Table__RegistersSelected__Button Tables__Table__RegistersSelected__Button--Sm' onClick={() => setSelectedVisibleIds([])}>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>X</span>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>Cerrar</span>
                                                            </button>

                                                            <div className='Tables__Table__RegistersSelected__Text'>
                                                                {selectedVisibleIds.length} ztudiante(s) seleccionada(s)
                                                            </div>

                                                            <button className='Tables__Table__RegistersSelected__Button Tables__Table__RegistersSelected__Button--Lg' onClick={() => setSelectedVisibleIds([])}>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>X</span>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>Cerrar</span>
                                                            </button>
                                                        </div>
                                                    )}

                                                    <section className='Tables__Container'>
                                                        <table className='Tables__Table Instructor__Ztudents__Visible__ContainerTable__Table'>
                                                            {selectedVisibleIds.length === 0 && (
                                                                <thead>
                                                                    <tr className='Tables__Table__Row--Header'>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__InputColumn Instructor__Ztudents__Visible__ContainerTable__Table__InputColumn'>
                                                                            <input
                                                                                type='checkbox'
                                                                                className='Tables__Table__InputColumn__Input'
                                                                                onChange={(e) => {
                                                                                    //const newIds = e.target.checked ? visibleRows.map(row => row.idZtudiante) : []
                                                                                    const newIds = e.target.checked ? processedVisibleRows.map(row => row.idZtudiante) : []
                                                                                    setSelectedVisibleIds(newIds)
                                                                                }}
                                                                                //checked={visibleRows.every(row => selectedVisibleIds.includes(row.idZtudiante)) && visibleRows.length > 0}
                                                                                checked={processedVisibleRows.length > 0 &&
                                                                                    processedVisibleRows.every(row => selectedVisibleIds.includes(row.idZtudiante))}
                                                                            />
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn Instructor__Ztudents__Visible__ContainerTable__Table__TextColumn' onClick={() => handleSortVisible('name')}>Nombre(s) {sortVisibleConfig.key === 'name' && <span>{sortVisibleConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn Instructor__Ztudents__Visible__ContainerTable__Table__TextColumn' onClick={() => handleSortVisible('lastName')}>Apellido(s) {sortVisibleConfig.key === 'lastName' && <span>{sortVisibleConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn Instructor__Ztudents__Visible__ContainerTable__Table__TextColumn' onClick={() => handleSortVisible('user')}>Usuario {sortVisibleConfig.key === 'user' && <span>{sortVisibleConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn Instructor__Ztudents__Visible__ContainerTable__Table__ActionButtonsColumn'></td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn Instructor__Ztudents__Visible__ContainerTable__Table__ActionButtonsColumn'></td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn Instructor__Ztudents__Visible__ContainerTable__Table__ActionButtonsColumn'></td>
                                                                    </tr>
                                                                </thead>
                                                            )}
                                                            <tbody>
                                                                {/* {sortedVisibleRows.map((row, index) => ( */}
                                                                {processedVisibleRows.map((row, index) => (
                                                                    <tr key={index} className='Tables__Table__Row'>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__InputColumn Instructor__Ztudents__Visible__ContainerTable__Table__InputColumn'>
                                                                            <input type='checkbox' className='Tables__Table__InputColumn__Input' checked={isVisibleSelected(row.idZtudiante)} onChange={() => toggleVisibleSelect(row.idZtudiante)}/>
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn Instructor__Ztudents__Visible__ContainerTable__Table__TextColumn'>{row.name}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn Instructor__Ztudents__Visible__ContainerTable__Table__TextColumn'>{row.lastName}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn Instructor__Ztudents__Visible__ContainerTable__Table__TextColumn'>{row.user}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn Instructor__Ztudents__Visible__ContainerTable__Table__ActionButtonsColumn'>
                                                                            <button onClick={async () => await ShowZtudentDetails(row, visibleRows)} className='Btn__Ztudia--PrimaryOutline'>Detalles</button>
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn Instructor__Ztudents__Visible__ContainerTable__Table__ActionButtonsColumn'>
                                                                            <button onClick={async () => await ShowConfirmModal(actions.HIDE, row)} className='Btn__Ztudia--PrimaryOutline'><i className='bi bi-eye-slash'></i> Ocultar</button>
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn Instructor__Ztudents__Visible__ContainerTable__Table__ActionButtonsColumn'>
                                                                            <button onClick={async () => await ShowConfirmModal(actions.RESET, row)} className='Btn__Ztudia--PrimaryOutline'><i className="bi bi-arrow-repeat"></i> Contraseña</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </section>
                                                </div>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <p className='Instructor__Text--Center'>No ha sido posible mostrar los Ztudiantes asociados a tu centro. Intenta actualizar la página o inténtalo más tarde.</p>
                                )}

                                
                                {hiddenRows ? (
                                    <>
                                        {hiddenRows.length > 0 && (
                                            <>
                                                <p className='Instructor__Title Instructor__Title--Center Instructor__SpaceUp'>Ztudiantes ocultos</p>
                                                <p className='Instructor__Subtitle Instructor__Subtitle--Center'>Total: {hiddenRows.length}</p>

                                                <Search onChange={(v) => setSearchHiddenText(v)} extraClassName={'Instructor__SpaceUp'} />

                                                <div className='container Instructor__SpaceUp Tables--Shadow Tables--Background'>
                                                    {selectedHiddenIds.length > 0 && (
                                                        <div className='Tables__ExtraButtons'>
                                                            <button
                                                                className='Btn__Ztudia--PrimaryOutline Tables__ExtraButtons__Button'
                                                                onClick={async () => {
                                                                    const selectedZtudents = await GetSelectedZtudentsByIds(selectedHiddenIds)
                                                                    
                                                                    await HandleMassiveZtudentAction({
                                                                        selectedRows: selectedZtudents,
                                                                        actionLabel: 'Mostrar',
                                                                        actionFn: ShowToZtudent,
                                                                        _actionTypeOfModal: actions.SHOW,
                                                                        allRowsRef,
                                                                        setAllRows,
                                                                        setVisibleRows,
                                                                        setHiddenRows,
                                                                        setMassiveSummary,
                                                                        setShowMassiveSummaryModal,
                                                                        setActionTypeOfModal,
                                                                        ClearSelections,
                                                                        logContext: '- mostrar ocultos'
                                                                    })
                                                                }}
                                                            >
                                                                Mostrar {selectedHiddenIds.length} Ztudiante(s)
                                                            </button>
                                                        </div>
                                                    )}

                                                    {selectedHiddenIds.length > 0 && (
                                                        <div className='Tables__Table__RegistersSelected'>
                                                            <button className='Tables__Table__RegistersSelected__Button Tables__Table__RegistersSelected__Button--Sm' onClick={() => setSelectedHiddenIds([])}>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>X</span>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>Cerrar</span>
                                                            </button>
                                                            
                                                            <div className='Tables__Table__RegistersSelected__Text'>
                                                                {selectedHiddenIds.length} ztudiante(s) seleccionada(s)
                                                            </div>

                                                            <button className='Tables__Table__RegistersSelected__Button Tables__Table__RegistersSelected__Button--Lg' onClick={() => setSelectedHiddenIds([])}>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>X</span>
                                                                <span className='Tables__Table__RegistersSelected__Button__Text'>Cerrar</span>
                                                            </button>
                                                        </div>
                                                    )}

                                                    <div className='Tables__Container'>
                                                        <table className='Tables__Table Instructor__Ztudents__Hidden__ContainerTable__Table'>
                                                            {selectedHiddenIds.length === 0 && (
                                                                <thead>
                                                                    <tr className='Tables__Table__Row--Header'>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__InputColumn Instructor__Ztudents__Hidden__ContainerTable__Table__InputColumn'>
                                                                            <input
                                                                                type='checkbox'
                                                                                className='Tables__Table__InputColumn__Input'
                                                                                onChange={(e) => {
                                                                                    //const newIds = e.target.checked ? hiddenRows.map(row => row.idZtudiante) : []
                                                                                    const newIds = e.target.checked ? processedHiddenRows.map(row => row.idZtudiante) : []
                                                                                    setSelectedHiddenIds(newIds)
                                                                                }}
                                                                                //checked={hiddenRows.every(row => selectedHiddenIds.includes(row.idZtudiante)) && hiddenRows.length > 0}
                                                                                checked={processedHiddenRows.length > 0 &&
                                                                                    processedHiddenRows.every(row => selectedHiddenIds.includes(row.idZtudiante))}
                                                                            />
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn Instructor__Ztudents__Hidden__ContainerTable__Table__TextColumn' onClick={() => handleSortHidden('name')}>Nombre(s) {sortHiddenConfig.key === 'name' && <span>{sortHiddenConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn Instructor__Ztudents__Hidden__ContainerTable__Table__TextColumn' onClick={() => handleSortHidden('lastName')}>Apellido(s) {sortHiddenConfig.key === 'lastName' && <span>{sortHiddenConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn Instructor__Ztudents__Hidden__ContainerTable__Table__TextColumn' onClick={() => handleSortHidden('user')}>Usuario {sortHiddenConfig.key === 'user' && <span>{sortHiddenConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn Instructor__Ztudents__Hidden__ContainerTable__Table__ActionButtonsColumn'></td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn Instructor__Ztudents__Hidden__ContainerTable__Table__ActionButtonsColumn'></td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn Instructor__Ztudents__Hidden__ContainerTable__Table__ActionButtonsColumn'></td>
                                                                    </tr>
                                                                </thead>
                                                            )}
                                                            <tbody>
                                                                {/* {sortedHiddenRows.map((row, index) => ( */}
                                                                {processedHiddenRows.map((row, index) => (
                                                                    <tr key={index} className='Tables__Table__Row'>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__InputColumn Instructor__Ztudents__Hidden__ContainerTable__Table__InputColumn'>
                                                                            <input type='checkbox' className='Tables__Table__InputColumn__Input' checked={isHiddenSelected(row.idZtudiante)} onChange={() => toggleHiddenSelect(row.idZtudiante)}/>
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn Instructor__Ztudents__Hidden__ContainerTable__Table__TextColumn'>{row.name}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn Instructor__Ztudents__Hidden__ContainerTable__Table__TextColumn'>{row.lastName}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn Instructor__Ztudents__Hidden__ContainerTable__Table__TextColumn'>{row.user}</td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn Instructor__Ztudents__Hidden__ContainerTable__Table__ActionButtonsColumn'>
                                                                            <button onClick={async () => await ShowZtudentDetails(row, hiddenRows)} className='Btn__Ztudia--PrimaryOutline'>Detalles</button>
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn Instructor__Ztudents__Hidden__ContainerTable__Table__ActionButtonsColumn'>
                                                                            <button onClick={async () => await ShowConfirmModal(actions.SHOW, row)} className='Btn__Ztudia--PrimaryOutline'><i className='bi bi-eye'></i> Mostrar</button>
                                                                        </td>
                                                                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn Instructor__Ztudents__Hidden__ContainerTable__Table__ActionButtonsColumn'>
                                                                            <button onClick={async () => await ShowConfirmModal(actions.RESET, row)} className='Btn__Ztudia--PrimaryOutline'><i className="bi bi-arrow-repeat"></i> Contraseña</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <p className='Instructor__Text--Center'>No ha sido posible mostrar el listado de Ztudiantes ocultos de tu centro. Intenta actualizar la página o inténtalo más tarde.</p>
                                )}



                                {showDetailsModal && (
                                    <Details
                                        stepButtons={true}
                                        actionToPreviousStepButton={() => PreviousStepButton()}
                                        showPreviousStepButton={showPreviousStepButton}
                                        actionToNextStepButton={() => NextStepButton()}
                                        showNextStepButton={showNextStepButton}
                                        showCloseModalButtonInContent={true}
                                        extraClassName={'Instructor__Ztudents__Details'}
                                        setShowModal={setShowDetailsModal}
                                        setDetailsData={setZtudentDetails}
                                    >
                                        <div className='Instructor__Ztudents__Details__Container'>
                                            <p className='Instructor__Ztudents__Details__Title'>Detalles de mis Ztudiantes</p>

                                            {ztudentDetails ? (
                                                <>
                                                    <p className='Instructor__Ztudents__Details__Text Instructor__Ztudents__Details__TextContainer'>Nombre(s): {ztudentDetails.name}</p>
                                                    <p className='Instructor__Ztudents__Details__Text Instructor__Ztudents__Details__TextContainer'>Apellido(s): {ztudentDetails.lastName}</p>
                                                    <p className='Instructor__Ztudents__Details__Text Instructor__Ztudents__Details__TextContainer'>Usuario: {ztudentDetails.user}</p>
                                                    <p className='Instructor__Ztudents__Details__Text Instructor__Ztudents__Details__TextContainer'>¿Está oculto?: {ztudentDetails.isVisible ? 'No' : 'Sí'}</p>
                                                    {ztudentDetails.groups && (
                                                        ztudentDetails.groups.length === 0 ? (
                                                            <p className='Instructor__Group__Details__Text Instructor__Group__Details__TextContainer'>Grupos en los que se encuentra: Ninguno</p>
                                                        ) : (
                                                            <>
                                                                <p className='Instructor__Group__Details__Text Instructor__Group__Details__TextContainer'>Grupos en los que se encuentra:</p>

                                                                <div className='Instructor__Group__Details__ContainerTable'>
                                                                    <table className='Instructor__Group__Details__Table'>
                                                                        <tbody>
                                                                            {ztudentDetails.groups.map((group,index) => (
                                                                                <tr key={index} className='Instructor__Group__Details__Table__Row'>
                                                                                    <td className='Instructor__Group__Details__Table__Row__Cell'>{group.groupName}</td>
                                                                                    <td className='Instructor__Group__Details__Table__Row__Cell'><button type='button' className='Btn__Ztudia--Link Instructor__Group__Details__Table__Row__Cell__Button' onClick={() => ShowGroup(group)}>Ir al grupo</button></td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </>
                                                        )
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <p className='Instructor__Ztudents__Details__Text'>No ha sido posible mostrar la información del Ztudiante.</p>
                                                    <p className='Instructor__Ztudents__Details__Text'>Intenta consultar su información nuevamente o inténtalo más tarde.</p>
                                                </>
                                            )}
                                        </div>
                                    </Details>
                                )}

                                {showConfirmationModal && (
                                    ztudentConfirmDetails && (
                                        actionTypeOfModal === actions.HIDE ? (
                                            <Confirm
                                                message={`¿Estás segur@ de ocultar al Ztudiante ${ztudentConfirmDetails?.name} ${ztudentConfirmDetails?.lastName} (${ztudentConfirmDetails?.user})?`}
                                                actionToYesButton={HideZtudent}
                                                textYesButton={'Sí, ocultar Ztudiante'}
                                                textNoButton={'No'}
                                                setShowModal={setShowConfirmationModal}
                                                setConfirmData={setZtudentConfirmDetails}
                                            />
                                        ) : actionTypeOfModal === actions.SHOW ? (
                                            <Confirm
                                                message={`¿Estás segur@ de mostrar al Ztudiante ${ztudentConfirmDetails?.name} ${ztudentConfirmDetails?.lastName} (${ztudentConfirmDetails?.user})?`}
                                                actionToYesButton={ShowZtudent}
                                                textYesButton={'Sí, mostrar Ztudiante'}
                                                textNoButton={'No'}
                                                setShowModal={setShowConfirmationModal}
                                                setConfirmData={setZtudentConfirmDetails}
                                            />
                                        ) : actionTypeOfModal === actions.RESET && (
                                            <Confirm
                                                message={`¿Estás segur@ de resetear la contraseña del Ztudiante ${ztudentConfirmDetails?.name} ${ztudentConfirmDetails?.lastName} (${ztudentConfirmDetails?.user})?`}
                                                actionToYesButton={ResetZtudiantePassword}
                                                textYesButton={'Sí, resetear contraseña'}
                                                textNoButton={'No'}
                                                setShowModal={setShowConfirmationModal}
                                                setConfirmData={setZtudentConfirmDetails}
                                            />
                                        )
                                    )
                                )}

                                {showMassiveSummaryModal && massiveSummary && (
                                    <Details
                                        stepButtons={false}
                                        showCloseModalButtonInContent={true}
                                        extraClassName={'Modal__Layout--Summary'}
                                        setShowModal={setShowMassiveSummaryModal}
                                        setDetailsData={setMassiveSummary}
                                    >
                                        <div className='Modal__Layout--Summary__Container'>
                                            <p className='Modal__Layout--Summary__Title'>Resumen {actionTypeOfModal === actions.HIDE ? 'de Ztudiantes ocultos' : actionTypeOfModal === actions.SHOW && 'de Ztudiantes mostrados'}</p>

                                            {massiveSummary ? (
                                                <>
                                                    {massiveSummary.successful.length > 0 && (
                                                        <>
                                                            <p className='Modal__Layout--Summary__Category'><i className='bi bi-check-circle'></i> {actionTypeOfModal === actions.HIDE ? 'Ztudiantes ocultos:' : actionTypeOfModal === actions.SHOW && 'Ztudiantes mostrados:'}</p>
                                                            <div className='Modal__Layout--Summary__TextContainer'>
                                                            {massiveSummary.successful.map((success,index) => (
                                                                <p key={index} className='Modal__Layout--Summary__TextContainer__Text'>{success.name} {success.lastName} ({success.user})</p>
                                                            ))}
                                                            </div>
                                                        </>
                                                    )}

                                                    {massiveSummary.wrongs.length > 0 && (
                                                        <>
                                                            <p className='Modal__Layout--Summary__Category'><i className="bi bi-x-circle"></i> {actionTypeOfModal === actions.HIDE ? 'Error al ocultarlo(s):' : actionTypeOfModal === actions.SHOW && 'Error al mostrarlo(s):'}</p>
                                                            <div className='Modal__Layout--Summary__TextContainer'>
                                                            {massiveSummary.wrongs.map((wrong,index) => (
                                                                <p key={index} className='Modal__Layout--Summary__TextContainer__Text'>{wrong.name} {wrong.lastName} ({wrong.user})</p>
                                                            ))}
                                                            </div>
                                                        </>
                                                    )}

                                                    {massiveSummary.omitteds.length > 0 && (
                                                        <>
                                                            <p className='Modal__Layout--Summary__Category'><i className="bi bi-skip-end-btn"></i> Omitidos:</p>
                                                            <div className='Modal__Layout--Summary__TextContainer'>
                                                            {massiveSummary.omitteds.map((omitted,index) => (
                                                                <p key={index} className='Modal__Layout--Summary__TextContainer__Text'>{omitted.name} {omitted.lastName} ({omitted.user})</p>
                                                            ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <p className='Modal__Layout--Summary__Text'>No ha sido posible mostrar el resumen de lo realizado.</p>
                                                </>
                                            )}
                                        </div>
                                    </Details>
                                )}
                            </>
                        )}
                    </section>
                </InstructorBase>
            </>
        )
    )
}

export { Ztudents };